import { render, staticRenderFns } from "./OverrideEditor.vue?vue&type=template&id=5681034f&"
import script from "./OverrideEditor.vue?vue&type=script&lang=js&"
export * from "./OverrideEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports